import React from 'react';
import './App.css';
import ImageFormatConverter from './pageindex';  // <-- Your file!

function App() {
  return (
    <div className="App">
      <ImageFormatConverter />  {/* <-- This runs your converter! */}
    </div>
  );
}

export default App;